// src/catalog/components/detail/CatalogEntryRelatedEntriesPanel.jsx

import {
  getRelatedEntryLabel,
  getRelationLabel
} from "./detailUtils";

export default function CatalogEntryRelatedEntriesPanel({
  relatedEntries = [],
  onSelectRelatedEntry
}) {
  if (relatedEntries.length === 0) {
    return null;
  }

  return (
    <div className="catalog-detail__panel">
      <h2>Related activities</h2>

      <div className="catalog-detail__related-list">
        {relatedEntries.map((relatedEntry) => (
          <button
            key={`${relatedEntry.relation}-${relatedEntry.slug}`}
            type="button"
            className="catalog-detail__related-entry"
            onClick={() => onSelectRelatedEntry?.(relatedEntry)}
          >
            <span className="catalog-detail__related-label">
              {getRelatedEntryLabel(relatedEntry)}
            </span>

            {relatedEntry.relation && (
              <span className="catalog-detail__related-relation">
                {getRelationLabel(relatedEntry.relation)}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}
